import type { EventParticipantRole, ProgramEventInviteeRole, ProgramUserRsvp } from 'models';
import { useCallback } from 'react';
import { useEventRsvpLabels, useGetEventRoleName } from '../../../../hooks';

export const useGetInviteesInformation = ({ isTelehealth }: { isTelehealth: boolean }) => {
  const getEventRoleName = useGetEventRoleName();
  const { getStatusListLabel } = useEventRsvpLabels();

  return useCallback(
    ({ role, rsvp }: { role: EventParticipantRole | ProgramEventInviteeRole; rsvp: ProgramUserRsvp }) => {
      const roleName = getEventRoleName({ isTelehealth, role });
      const statusLabel = getStatusListLabel({ rsvp });

      return [
        { content: roleName, key: role },
        { content: statusLabel, key: rsvp },
      ];
    },
    [getEventRoleName, isTelehealth, getStatusListLabel],
  );
};
